import { render, staticRenderFns } from "./MyPageHeader.vue?vue&type=template&id=790f3161"
import script from "./MyPageHeader.vue?vue&type=script&lang=js"
export * from "./MyPageHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports